import Swiper from 'https://unpkg.com/swiper@7/swiper-bundle.esm.browser.min.js'

export class ProductSwiper extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.sectionId
    this.hideVariants = this.hasAttribute('data-hide-variants') ? true : false
    this.soom = this.hasAttribute('data-zoom') ? true : false
    this.initialSlide = !this.hideVariants ? parseInt(this.dataset.initialSlide, 10) : 0
    this.thumbElement = this.querySelector('.thumb-swiper-container')
    this.mainElement = this.querySelector('.product-swiper-container')
    this.init()

    if (!this.hideVariants) { 
      document.addEventListener("variantChange", (evt) => {
        let variant = evt.context.variant
        if (!this.hideVariants) {
          this.slideToVariant(variant)
        }
      })
    }
      
  }

  init() {
    let thumbSwiper = false;
    if (this.thumbElement) {
      thumbSwiper = new Swiper(this.thumbElement,  {
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 12,
        mousewheel: true,
        cssMode: true,
        initialSlide: this.initialSlide,
        preventClicks: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
      this.thumbElement.parentElement.classList.add('md:block')
    }

    if (this.mainElement) {
      const productSwiper = new Swiper(this.mainElement,  {
        direction: 'horizontal',
        slidesPerView: 1.1,
        mousewheel: true,
        cssMode: true,
        initialSlide: this.initialSlide,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        // Navigation arrows
        navigation: false,
        zoom: this.soom,
        thumbs: {
          swiper: thumbSwiper && thumbSwiper
        },
        breakpoints: {
          768: {
            pagination: false
          }
        }
      })
      this.productSwiper = productSwiper
    }
  }

  slideToVariant(variant) {
    if (variant.featured_media && variant.featured_media.id) {
      let media = this.mainElement.querySelector(`[data-media-id="${this.id}-${variant.featured_media.id}"]`)
      if (media){
        let id = parseInt(media.dataset.position, 10)
        this.productSwiper.slideTo(id)
      }
    }
  }

}
customElements.define('product-swiper', ProductSwiper);